import { Box, Button, IconButton, Tooltip, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import Iconify from '../../../components/Iconify';
import usePermissions from '../../../hooks/usePermissions';
import { ACCESS_PROFILE_COPY } from '../../../constants/accessProfileCopy';

export default function ProfilePreviewHeaderBar() {
  const theme = useTheme();
  const { isAdmin, isPreviewActive, previewProfileCode, previewProfileName, clearPreview } =
    usePermissions();

  if (!isAdmin || !isPreviewActive || !previewProfileName || !previewProfileCode) {
    return null;
  }

  const copy = ACCESS_PROFILE_COPY[previewProfileCode];
  const contrastColor =
    theme.palette.mode === 'dark' ? theme.palette.warning.light : theme.palette.warning.darker;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        border: '1px solid',
        borderColor: alpha(contrastColor, 0.4),
        borderRadius: 1,
        bgcolor: alpha(contrastColor, theme.palette.mode === 'dark' ? 0.12 : 0.08),
        px: { xs: 1, sm: 1.25 },
        py: 0.5,
        maxWidth: { xs: 200, sm: 280, md: 360 },
        minWidth: 0,
      }}
    >
      <Iconify
        icon="mdi:eye-outline"
        width={18}
        height={18}
        sx={{ color: contrastColor, flexShrink: 0, display: { xs: 'none', sm: 'block' } }}
      />

      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography variant="subtitle2" noWrap sx={{ color: contrastColor, lineHeight: 1.2 }}>
          Preview — {previewProfileName}
        </Typography>
        {/* <Typography
          variant="caption"
          noWrap
          sx={{
            color: alpha(contrastColor, 0.78),
            display: { xs: 'none', md: 'block' },
            lineHeight: 1.2,
          }}
        >
          Somente UI · permissões reais no servidor
        </Typography> */}
      </Box>

      <Tooltip title={copy.description} arrow placement="bottom">
        <IconButton
          size="small"
          sx={{
            display: { xs: 'none', md: 'inline-flex' },
            color: contrastColor,
            flexShrink: 0,
          }}
        >
          <Iconify icon="eva:info-outline" width={18} height={18} />
        </IconButton>
      </Tooltip>

      <Button
        size="small"
        variant="outlined"
        onClick={() => clearPreview?.()}
        sx={{
          flexShrink: 0,
          minWidth: 'auto',
          px: { xs: 1, sm: 1.25 },
          color: contrastColor,
          borderColor: alpha(contrastColor, 0.4),
          '&:hover': {
            borderColor: contrastColor,
            bgcolor: alpha(contrastColor, 0.08),
          },
        }}
      >
        Sair
      </Button>
    </Box>
  );
}
